import { Icon } from '@/components/wm';
import * as React from 'react';

export default function HeaderMessage({ variant = 'destructive', message }) {
    const variantClasses = {
        destructive: 'tw-bg-destructive/30 tw-text-default dark:tw-border-destructive [&>svg]:tw-text-destructive [&>h5]:tw-text-destructive tw-border-destructive',
        warning: 'tw-bg-amber-400/20 tw-text-default dark:tw-border-amber-400 [&>svg]:tw-text-amber-800 [&>h5]:tw-text-amber-800 tw-border-amber-800',
        success: 'tw-bg-green-600/20 tw-text-default dark:tw-border-secondary [&>svg]:tw-text-secondary [&>h5]:tw-text-secondary tw-border-green-600',
        info: 'tw-bg-info/20 tw-text-default dark:tw-border-info-foreground [&>svg]:tw-text-info-foreground [&>h5]:tw-text-info-foreground tw-border-sky-800'
    };

    return (
        <div className={`tw-mb-6 tw-border-solid tw-border-l-4 tw-p-4 tw-rounded-r-lg ${variantClasses[variant]}`}>
            <div className="tw-flex tw-items-center tw-font-bold">
                <Icon className="tw-mr-2" color={variant} icon={variant}/>
                {message}
            </div>
        </div>
    );
}
